import { useSelector } from 'react-redux';
import { RootState } from '../store';
import ja from '../locales/ja.json';
import en from '../locales/en.json';

const translations = {
  ja,
  en
};

export const useTranslation = () => {
  const language = useSelector((state: RootState) => state.ui.language);
  
  const t = (key: string): string => {
    const keys = key.split('.');
    let value: any = (translations as any)[language];
    
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        console.warn(`Translation key not found: ${key}`);
        return key;
      }
    }
    
    return value || key;
  };
  
  return { t, language };
};